module.exports = __webpack_public_path__ + "static/media/logo.2a84d6f5.png";